import { c as _c } from "react/compiler-runtime";
import { useContext } from 'react';
import { Route, Switch, useRouteMatch } from 'react-router';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import useSWR from 'swr';
import APIMethodKeys from '../../../../../client/APIMethodKeys';
import Button from '../../../../common/base/Button';
import Container from '../../../../common/base/Container';
import Loading from '../../../../common/base/Loading';
import Tabs from '../../../../common/base/Tabs';
import Text from '../../../../common/base/Text';
import { useDialog } from '../../../../common/Dialog';
import { Div } from '../../../../common/helpers/StyledUtils';
import { useToasts } from '../../../../common/Toast';
import { GlobalContext } from '../../../../contexts/GlobalContext';
import { StyledViewNavActions, StyledViewContent, StyledViewNav, StyledViewNavHeader, StyledViewNavSecondary, StyledViewLayout, ViewBreadcrumbsTitle } from '../../../../layouts/ViewLayout';
import NotFound from '../../NotFound';
import { SourceConnections } from './SourceConnections';
import { SourceMetrics } from './SourceMetrics';
import { SourceOverview } from './SourceOverview';
import { SourceSettings } from './SourceSettings';
import { APISource } from '../../../../../../../../typings/Source.interface';
const SourceView = t0 => {
  const $ = _c(86);
  const {
    id: id_prop,
    mutate_sources
  } = t0;
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  const {
    params: t1
  } = useRouteMatch();
  const {
    id: id_param
  } = t1;
  const id = id_prop || id_param;
  const location = useLocation();
  const {
    addToast
  } = useToasts();
  const showDialog = useDialog();
  let t2;
  if ($[0] !== id) {
    t2 = APIMethodKeys.sources.get(id, {
      include: "config.auth"
    });
    $[0] = id;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== HookdeckAPI.sources || $[3] !== id) {
    t3 = () => HookdeckAPI.sources.get(id, {
      include: "config.auth"
    });
    $[2] = HookdeckAPI.sources;
    $[3] = id;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const {
    data: source,
    mutate,
    error
  } = useSWR(t2, t3);
  let t4;
  if ($[5] !== source) {
    t4 = source ? APIMethodKeys.webhooks.count({
      source_id: source.id
    }) : null;
    $[5] = source;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== HookdeckAPI.webhooks || $[8] !== source?.id) {
    t5 = () => HookdeckAPI.webhooks.count({
      source_id: source?.id
    });
    $[7] = HookdeckAPI.webhooks;
    $[8] = source?.id;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const {
    data: connections_count
  } = useSWR(t4, t5);
  let t6;
  if ($[10] !== mutate || $[11] !== mutate_sources) {
    t6 = source_0 => {
      mutate(source_0);
      mutate_sources?.();
    };
    $[10] = mutate;
    $[11] = mutate_sources;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const mutate_all = t6;
  let t7;
  if ($[13] !== HookdeckAPI.sources || $[14] !== addToast || $[15] !== id || $[16] !== mutate_all) {
    t7 = async () => {
      HookdeckAPI.sources.enable(id).then(source_1 => {
        mutate_all(source_1);
        addToast("success", "Source enabled");
      }).catch(() => {
        addToast("error", "Failed to enable source");
      });
    };
    $[13] = HookdeckAPI.sources;
    $[14] = addToast;
    $[15] = id;
    $[16] = mutate_all;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  const onEnable = t7;
  let t8;
  if ($[18] !== HookdeckAPI.sources || $[19] !== addToast || $[20] !== id || $[21] !== mutate_all || $[22] !== showDialog) {
    t8 = async () => {
      showDialog(() => {
        HookdeckAPI.sources.disable(id).then(source_2 => {
          mutate_all(source_2);
          addToast("success", "Source disabled");
        }).catch(() => {
          addToast("error", "Failed to disable source");
        });
      }, _temp, {
        title: "Disable source",
        submit_label: "Disable",
        cancel_label: "Cancel",
        message: "By disabling this source, all connections associated with this source will also be disabled. Are you sure?"
      });
    };
    $[18] = HookdeckAPI.sources;
    $[19] = addToast;
    $[20] = id;
    $[21] = mutate_all;
    $[22] = showDialog;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  const onDisable = t8;
  if (error && error.response?.status === 404) {
    let t9;
    if ($[24] !== id) {
      t9 = <NotFound title="Source not found" description="This source does not exist or has been deleted." id={id} />;
      $[24] = id;
      $[25] = t9;
    } else {
      t9 = $[25];
    }
    return t9;
  }
  if (error && error.response?.status === 410) {
    let t9;
    if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
      t9 = {
        justify: "center"
      };
      $[26] = t9;
    } else {
      t9 = $[26];
    }
    let t10;
    if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
      t10 = <Text semi={true} center={true} size="l">Source deleted</Text>;
      $[27] = t10;
    } else {
      t10 = $[27];
    }
    let t11;
    if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
      t11 = <Text as="p" m={{
        t: 4,
        b: 2
      }}>This source was permanently deleted.</Text>;
      $[28] = t11;
    } else {
      t11 = $[28];
    }
    let t12;
    if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
      t12 = <StyledViewLayout><StyledViewContent><Div flex={t9} p={8}><Container small={true} center={true}>{t10}{t11}<Button primary={true} ghost={true} m={{
                t: 4
              }} as={RouterLink} to="/connections">Connections</Button></Container></Div></StyledViewContent></StyledViewLayout>;
      $[29] = t12;
    } else {
      t12 = $[29];
    }
    return t12;
  }
  if (!source) {
    let t9;
    if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
      t9 = <Div m={{
        t: 8
      }}><Loading /></Div>;
      $[30] = t9;
    } else {
      t9 = $[30];
    }
    return t9;
  }
  const t9 = source?.name || id;
  let t10;
  if ($[31] !== t9) {
    t10 = {
      label: t9,
      highlight: true
    };
    $[31] = t9;
    $[32] = t10;
  } else {
    t10 = $[32];
  }
  const title_breadcrumb = t10;
  let t11;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      label: "Sources",
      to: "/sources"
    };
    $[33] = t11;
  } else {
    t11 = $[33];
  }
  let t12;
  if ($[34] !== title_breadcrumb) {
    t12 = [t11, title_breadcrumb];
    $[34] = title_breadcrumb;
    $[35] = t12;
  } else {
    t12 = $[35];
  }
  const breadcrumbs = t12;
  const t13 = `/sources/${id}`;
  let t14;
  if ($[36] !== t13) {
    t14 = {
      label: "Overview",
      key: "overview",
      to: t13
    };
    $[36] = t13;
    $[37] = t14;
  } else {
    t14 = $[37];
  }
  const t15 = `/sources/${id}/metrics`;
  let t16;
  if ($[38] !== t15) {
    t16 = {
      label: "Metrics",
      key: "metrics",
      to: t15
    };
    $[38] = t15;
    $[39] = t16;
  } else {
    t16 = $[39];
  }
  const t17 = `/sources/${id}/connections`;
  const t18 = connections_count?.count;
  let t19;
  if ($[40] !== t17 || $[41] !== t18) {
    t19 = {
      label: "Connections",
      key: "connections",
      to: t17,
      badge_label: t18,
      badge_theme: "muted"
    };
    $[40] = t17;
    $[41] = t18;
    $[42] = t19;
  } else {
    t19 = $[42];
  }
  const t20 = `/sources/${id}/settings`;
  let t21;
  if ($[43] !== t20) {
    t21 = {
      label: "Settings",
      key: "settings",
      to: t20
    };
    $[43] = t20;
    $[44] = t21;
  } else {
    t21 = $[44];
  }
  let t22;
  if ($[45] !== t14 || $[46] !== t16 || $[47] !== t19 || $[48] !== t21) {
    t22 = {
      OVERVIEW: t14,
      METRICS: t16,
      CONNECTIONS: t19,
      SETTINGS: t21
    };
    $[45] = t14;
    $[46] = t16;
    $[47] = t19;
    $[48] = t21;
    $[49] = t22;
  } else {
    t22 = $[49];
  }
  const TABS = t22 as const;
  let t23;
  if ($[50] !== breadcrumbs) {
    t23 = <ViewBreadcrumbsTitle breadcrumbs={breadcrumbs} />;
    $[50] = breadcrumbs;
    $[51] = t23;
  } else {
    t23 = $[51];
  }
  const t24 = source?.disabled_at ? onEnable : onDisable;
  const t25 = source?.disabled_at ? "add_circle" : "disable";
  const t26 = source?.disabled_at ? "Enable" : "Disable";
  let t27;
  if ($[52] !== t24 || $[53] !== t25 || $[54] !== t26) {
    t27 = <StyledViewNavActions><Button.Permission role="member" outline={true} onClick={t24} icon={t25}>{t26} source</Button.Permission></StyledViewNavActions>;
    $[52] = t24;
    $[53] = t25;
    $[54] = t26;
    $[55] = t27;
  } else {
    t27 = $[55];
  }
  let t28;
  if ($[56] !== t23 || $[57] !== t27) {
    t28 = <StyledViewNavHeader>{t23}{t27}</StyledViewNavHeader>;
    $[56] = t23;
    $[57] = t27;
    $[58] = t28;
  } else {
    t28 = $[58];
  }
  let t29;
  if ($[59] !== location.pathname) {
    t29 = location.pathname.split("/")[3] || "overview";
    $[59] = location.pathname;
    $[60] = t29;
  } else {
    t29 = $[60];
  }
  let t30;
  if ($[61] !== TABS) {
    t30 = Object.values(TABS);
    $[61] = TABS;
    $[62] = t30;
  } else {
    t30 = $[62];
  }
  let t31;
  if ($[63] !== t29 || $[64] !== t30) {
    t31 = <StyledViewNavSecondary><Tabs active_tab={t29} border={false} tabs={t30} /></StyledViewNavSecondary>;
    $[63] = t29;
    $[64] = t30;
    $[65] = t31;
  } else {
    t31 = $[65];
  }
  let t32;
  if ($[66] !== t28 || $[67] !== t31) {
    t32 = <StyledViewNav>{t28}{t31}</StyledViewNav>;
    $[66] = t28;
    $[67] = t31;
    $[68] = t32;
  } else {
    t32 = $[68];
  }
  let t33;
  if ($[69] !== source) {
    t33 = <Route exact={true} path="/sources/:id" render={() => <SourceOverview source={source} />} />;
    $[69] = source;
    $[70] = t33;
  } else {
    t33 = $[70];
  }
  let t34;
  if ($[71] !== source) {
    t34 = <Route path="/sources/:id/metrics" render={() => <SourceMetrics source={source} />} />;
    $[71] = source;
    $[72] = t34;
  } else {
    t34 = $[72];
  }
  let t35;
  if ($[73] !== source) {
    t35 = <Route path="/sources/:id/connections" render={() => <SourceConnections source={source} />} />;
    $[73] = source;
    $[74] = t35;
  } else {
    t35 = $[74];
  }
  let t36;
  if ($[75] !== mutate_all || $[76] !== source) {
    t36 = <Route path="/sources/:id/settings" render={() => <SourceSettings source={source} mutate={mutate_all} />} />;
    $[75] = mutate_all;
    $[76] = source;
    $[77] = t36;
  } else {
    t36 = $[77];
  }
  let t37;
  if ($[78] !== t33 || $[79] !== t34 || $[80] !== t35 || $[81] !== t36) {
    t37 = <Switch>{t33}{t34}{t35}{t36}</Switch>;
    $[78] = t33;
    $[79] = t34;
    $[80] = t35;
    $[81] = t36;
    $[82] = t37;
  } else {
    t37 = $[82];
  }
  let t38;
  if ($[83] !== t32 || $[84] !== t37) {
    t38 = <StyledViewLayout><StyledViewContent>{t32}{t37}</StyledViewContent></StyledViewLayout>;
    $[83] = t32;
    $[84] = t37;
    $[85] = t38;
  } else {
    t38 = $[85];
  }
  return t38;
};
export default SourceView;
function _temp() {
  return null;
}